import { render, staticRenderFns } from "./AlterarSenhaInterno.vue?vue&type=template&id=471f27e5"
import script from "./AlterarSenhaInterno.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaInterno.vue?vue&type=script&lang=js"
import style0 from "./AlterarSenhaInterno.vue?vue&type=style&index=0&id=471f27e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports